import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowLeft, Lock } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { BrandLogo } from '../Brand';
import { PUBLIC_SITE_NAME } from '../../config/brand';

const AdminSignIn = () => {
  const { login, loginWithPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await loginWithPassword(email.trim(), password);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Could not sign you in. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A1551] flex flex-col items-center justify-center p-6" data-testid="admin-signin">
      <div className="w-full max-w-[420px] bg-white rounded-2xl shadow-2xl p-8">
        <div className="flex items-center gap-2 mb-6">
          <BrandLogo size="sm" />
          <span className="px-2 py-0.5 rounded-full bg-[#E6F4F2] text-[#0F766E] text-[11px] font-bold uppercase tracking-wide">Admin</span>
        </div>
        <h1 className="text-[24px] font-bold text-[#0A1551] flex items-center gap-2"><Lock className="w-5 h-5 text-[#0F766E]" /> Administrator sign-in</h1>
        <p className="text-[14px] text-[#6F76A7] mt-1 mb-6">This area is restricted to {PUBLIC_SITE_NAME} administrators.</p>

        <form onSubmit={submit} className="space-y-3" data-testid="admin-signin-form">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@cathiewoodcapital.com" autoComplete="email" data-testid="admin-signin-email"
            className="w-full px-3 py-2.5 border border-[#D5D7ED] rounded-md text-[15px] text-[#0A1551] focus:outline-none focus:border-[#0A1551]" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" autoComplete="current-password" data-testid="admin-signin-password"
            className="w-full px-3 py-2.5 border border-[#D5D7ED] rounded-md text-[15px] text-[#0A1551] focus:outline-none focus:border-[#0A1551]" />
          {error && <p className="text-[13px] text-[#E5387B]" role="alert" data-testid="admin-signin-error">{error}</p>}
          <button type="submit" disabled={!email || !password || busy} data-testid="admin-signin-submit"
            className="w-full px-4 py-3 rounded-md bg-[#0F766E] hover:bg-[#0B5F58] text-white text-[15px] font-semibold disabled:opacity-50">
            {busy ? 'Signing in…' : 'Sign in to admin'}
          </button>
        </form>

        <div className="flex items-center gap-3 my-5">
          <span className="flex-1 h-px bg-[#E3E5F5]" />
          <span className="text-[12px] text-[#9599C0]">or</span>
          <span className="flex-1 h-px bg-[#E3E5F5]" />
        </div>

        <button onClick={login} data-testid="admin-signin-google"
          className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-md border border-[#D5D7ED] text-[15px] font-semibold text-[#0A1551] hover:bg-[#F5F6FB]">
          <ShieldCheck className="w-4 h-4 text-[#0F766E]" /> Continue with Google
        </button>
      </div>

      <Link to="/" data-testid="admin-signin-back" className="mt-6 inline-flex items-center gap-2 text-[14px] font-semibold text-white/80 hover:text-white">
        <ArrowLeft className="w-4 h-4" /> Back to {PUBLIC_SITE_NAME}
      </Link>
    </div>
  );
};

export default AdminSignIn;
